import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExpenseService {

  constructor(private http: HttpClient) { }

  getVCountryOptions(): Observable<any> {
    const url = `${environment.expenseApiUrl}/common/getVCountry`;
    return this.http.get(url);
  }

  getVCityOptions(): Observable<any> {
    const url = `${environment.expenseApiUrl}/common/getVCity`;
    return this.http.get(url);
  }


  getVAreaOptions(): Observable<any> {
    const url = `${environment.expenseApiUrl}/common/getVArea`;
    return this.http.get(url);
  }

  findFacilityOptionsByOptionType(optionType: string): Observable<any> {
    const url = `${environment.expenseApiUrl}/common/findFacilityOptionsByOptionType/${optionType}`;
    return this.http.get(url);
  }


  findFeeTypeByFeeTypeCategory(feeTypeCategory: string): Observable<any> {
    const url = `${environment.expenseApiUrl}/common/findFeeTypeByFeeTypeCategory/${feeTypeCategory}`;
    return this.http.get(url);
  }

  findBillingViewer(bookingNo: string): Observable<any> {
    const url = `${environment.expenseApiUrl}/billing/billingViewer/${bookingNo}`;
    return this.http.get(url);
  }

  modifyBillingDetail(billingDetail: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/billing/modifyBillingDetail`;
    return this.http.post(url, billingDetail);
  }

  billingViewerAccountCodeMap(type: any, feature: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/billing/billingViewerAccountCodeMap/${type}/${feature}`;
    return this.http.get(url);
  }

  saveBilling(req: any): Observable<any>{
    const url = `${environment.expenseApiUrl}/billing/saveBilling`;
    return this.http.post(url, req);
  }

  getTransPreviewCalculate(bookingNo: string, feature: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/expense/preview/${bookingNo}/${feature}`;
    return this.http.get(url);
  }

  downloadRfqByExcel(file: any, seqNos: string): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('seqNos', seqNos);

    const url = `${environment.expenseApiUrl}/import/downloadRfqByExcel`;
    let response = this.http.put(url, formData, {
      reportProgress: true,
      responseType: 'blob'
    });
    return response;
  }

  calculationOfAllForwarder(rfqPreChargeRequest: any): Observable<any> {
    const url = `${environment.expenseApiUrl}/rfqBuget/calculation/all/forwarder`;
    return this.http.post(url, rfqPreChargeRequest);
  }

  exportFreightTrail(dataList: any[]): Observable<any> {
    const url = `${environment.expenseApiUrl}/rfqBuget/export/freightFeeCalculation`;
    return this.http.post(url, dataList, { responseType: 'blob'});
  }
}
